import { render, staticRenderFns } from "./pinboardView.vue?vue&type=template&id=588fc2ac&scoped=true"
import script from "./pinboardView.vue?vue&type=script&lang=js"
export * from "./pinboardView.vue?vue&type=script&lang=js"
import style0 from "./pinboardView.vue?vue&type=style&index=0&id=588fc2ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588fc2ac",
  null
  
)

export default component.exports